export default function loadListGroupVideo($lists: NodeListOf<HTMLDivElement>) {
	$lists.forEach(($list) => {
		const $videos = $list.querySelectorAll<HTMLVideoElement>('video');
		const $tabs = $list.querySelectorAll<HTMLAnchorElement>(`a.list-group-item`);

		$tabs.forEach(($tab) => {
			$tab.addEventListener('click', () => {
				$videos.forEach(($video) => $video.pause());
			});
		});
	});
}
